import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	retry: {
		id: 'navigation-apps.common.compontents.switcher.switcher.menu-list.error.retry',
		defaultMessage: 'Try again',
		description: 'Text displayed in Retry button in scope switchers, used in navigation',
	},
});
